export const ContextualMenuHelper = () => ({
    bindContextualMenu: () => {
        const stickyClass = 'contextual-menu--sticky';
        let scrollFrame;

        const updateStickyMenus = () => {
            const header = document.querySelector('.header-wrapper .sf-header__wrapper')
                || document.querySelector('.header-wrapper');
            const headerBottom = header ? Math.max(header.getBoundingClientRect().bottom, 0) : 0;

            document.querySelectorAll('.contextual-menu').forEach((menu) => {
                const originalTop = Number(menu.dataset.contextualMenuTop);

                if (menu.classList.contains(stickyClass)) {
                    if (window.scrollY + headerBottom < originalTop) {
                        menu.classList.remove(stickyClass);
                        menu.style.removeProperty('--contextual-menu-sticky-top');
                        menu.style.removeProperty('--contextual-menu-sticky-left');
                        menu.style.removeProperty('--contextual-menu-sticky-width');
                    } else {
                        const parentRect = menu.parentElement.getBoundingClientRect();

                        menu.style.setProperty('--contextual-menu-sticky-top', `${headerBottom}px`);
                        menu.style.setProperty('--contextual-menu-sticky-left', `${parentRect.left}px`);
                        menu.style.setProperty('--contextual-menu-sticky-width', `${parentRect.width}px`);
                    }
                    return;
                }

                const menuRect = menu.getBoundingClientRect();
                const menuTop = menuRect.top + window.scrollY;
                menu.dataset.contextualMenuTop = menuTop;

                if (menuRect.top <= headerBottom) {
                    menu.style.setProperty('--contextual-menu-sticky-top', `${headerBottom}px`);
                    menu.style.setProperty('--contextual-menu-sticky-left', `${menuRect.left}px`);
                    menu.style.setProperty('--contextual-menu-sticky-width', `${menuRect.width}px`);
                    menu.classList.add(stickyClass);
                }
            });
        };

        const scheduleStickyMenuUpdate = () => {
            if (scrollFrame) return;

            scrollFrame = window.requestAnimationFrame(() => {
                scrollFrame = undefined;
                updateStickyMenus();
            });
        };

        document.querySelector('body').addEventListener('click', function(evt) {
            if (evt.target.closest('.contextual-menu .menu-container .list-item.submenu')) {
                evt.target.closest('.contextual-menu .menu-container .list-item.submenu').classList.toggle("active");
            } else {
                document.querySelectorAll('.contextual-menu .menu-container .list-item.submenu').forEach(function(el) {
                    el.classList.remove("active");
                });
            }

            if (evt.target.closest('.list-title')) {
                evt.target.closest('.list-title').parentNode.classList.toggle("active");
            } else if (evt.target.matches('.list-title')) {
                evt.target.parentNode.classList.toggle("active");
            }
        }, true);

        window.addEventListener('scroll', scheduleStickyMenuUpdate, { passive: true });
        window.addEventListener('resize', scheduleStickyMenuUpdate);
        updateStickyMenus();
    }
});

export default ContextualMenuHelper;
